export default function summarizeList(list: string[], maxLength = 2): string {
  if (list.length <= maxLength) {
    return list.join(', ')
  }
  return `${list.slice(0, maxLength).join(', ')}, + ${
    list.length - maxLength
  } more`
}
